import React, {  useState } from 'react';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import {getAll,create,deleteTest} from '../../services/testService';



const TestWidget = () => {
const [testData, setTestData] = useState(null); 
const [name, setName] = useState('');
const [nameError, setNameError] = useState('');

const validateName = (value) => {
  if (!value || !value.trim()) {
    return 'Name is required';
  }
  return '';
};
  
   const fetchData = async () => {
      try {
        const data = await getAll();        
        setTestData(data.tests);
        console.log('Fetched test data:', data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };


  React.useEffect(() => {
    fetchData();
  }, []);  

  if (!testData) {
    return <div>Loading...</div>;
  }

const handleCreateClick = async () => {
  const error = validateName(name);
  if (error) {
    setNameError(error);
    return;
  }
  setNameError('');

  try {
    const newTest = { name: name, description: 'This is a new test entry.' };
    const createdTest = await create(newTest);
    console.log('Created test:', createdTest);
    setName('');
    fetchData(); // Refresh the list after creating a new test
  } catch (error) {
    console.error('Error creating test:', error);
  }
}; 

const handleDelete = async (id) => {
      try {
        await deleteTest(id);        
        fetchData(); // Refresh the list after deleting a test
      } catch (error) {
        console.error('Error deleting test:', error);   
    }
  };


  return (
   <Card className="w-full">
  <div className="flex flex-column gap-3">
    <div className="flex align-items-center justify-content-between">
      <h3 className="m-0">Test Widget</h3>
      <div className="flex align-items-start gap-2">
        <div className="flex flex-column">
          {nameError && <small className="p-error mb-1">{nameError}</small>}
          <InputText
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter name"
            className={nameError ? 'p-invalid' : ''}
          />
        </div>
        <Button label="Create Test" icon="pi pi-plus" onClick={handleCreateClick} />
      </div>
    </div>
    <div className="flex flex-column gap-2">
      {testData.map((item, index) => (
        <div key={index}>
          <h4>{item.name}</h4>
          <p>
            {item.description}
            <Button
              label="Delete"
              icon="pi pi-trash"
              className="p-button-danger p-button-text"
              onClick={() => handleDelete(item._id)}
            />
          </p>
        </div>
      ))}
    </div>
  </div>
</Card>
  );
};

export default TestWidget;